import { render, staticRenderFns } from "./CurrentFlight.vue?vue&type=template&id=80f67a74&scoped=true&"
import script from "./CurrentFlight.vue?vue&type=script&lang=js&"
export * from "./CurrentFlight.vue?vue&type=script&lang=js&"
import style0 from "./CurrentFlight.vue?vue&type=style&index=0&id=80f67a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f67a74",
  null
  
)

export default component.exports